import { initTxGa, login, logout, provideTxGA, registration, setLang } from 'services/global-auth-provider';

if (!window.WT) window.WT = {};
if (!window.WT.gaProvider) {
    window.WT.gaProvider = {
        provideTxGA,
        initTxGa,
        setLang,
        login,
        logout,
        registration,
    };
}
